import { DateTime } from "luxon";

function isValidated(validationDate: DateTime, date: DateTime): boolean {
  return validationDate >= date;
}

export { isValidated };
